import { useContext } from 'react';

import { PromoModelContext } from '../contexts/PromoModelProvider';

export const usePromoModel = () => useContext(PromoModelContext);
